import Validation from "shared/form/Validation";
import { useCopies } from "shared/hooks/useCopies";
import * as yup from "yup";
import flatten from "lodash/flatten";
import { useMemo } from "react";
import { FormFieldOption } from "shared/form/fields/types";
import ApiField from "shared/types/ApiField";
import FieldRenderType from "shared/form/renderer/enums/FieldRenderType";

export enum FeaturedSelectionFormFields {
  ID = "id",
  SELECTION_TYPES = "selectionTypes",
  DISPLAY_ORDER = "displayOrder",

  CONTEXT_ID = "contextId",
  CONTEXT_ENTITY_TYPE = "contextEntityType",
  DISPLAY_LABEL = "displayLabel",
  SHORT_DISPLAY_LABEL = "shortDisplayLabel",
  DESCRIPTION = "description",
  AVAILABILITY_TYPES = "availabilityTypes",
  MATCHED_DISPLAY_TEXT = "matchedDisplayText",
  UNMATCHED_DISPLAY_TEXT = "unmatchedDisplayText",
  SECONDARY_FILTERS = "secondaryFilters",
  ACTOR_CRITERIA = "actorCriteria",
  RECIPIENT_MATCH_CRITERIA_TYPE = "recipientMatchCriteriaType",
  RECIPIENT_CRITERIA = "recipientCriteria",
  RECIPIENT_FIELD_MAPPING = "recipientFieldMapping",
  GROUP_BY_TYPE = "groupByType",
  GROUP_BY_CARD_CONFIGURATION_ID = "groupByCardConfigurationId",
  GROUP_BY_CARD_CONFIGURATION = "groupByCardConfiguration",
  SELECTABLE_CARD_CONFIGURATION_ID = "selectableCardConfigurationId",
  SELECTABLE_CARD_CONFIGURATION = "selectableCardConfiguration",
  SELECTABLE_TYPE = "selectableType",
  TYPE = "type",
  TAGS = "tags",
  SUB_ROLES = "subRoles",
  UI_VERSION = "uiVersion"
}

export enum FieldMappingFormFields {
  SENDER_FIELD_ID = "senderFieldId",
  RECEPIENT_FIELD_ID = "recipientFieldId",
  FIELD_OPTION_MAPPINGS = "fieldOptionMappings"
}

export function useValidationSchemaForFieldMappings() {
  const copies = useCopies();
  const validation = useMemo(() => {
    return yup.object().shape({
      [FieldMappingFormFields.SENDER_FIELD_ID]: Validation.textFieldValidation({ copies, required: true }),
      [FieldMappingFormFields.RECEPIENT_FIELD_ID]: Validation.textFieldValidation({ copies, required: true }),
      [FieldMappingFormFields.FIELD_OPTION_MAPPINGS]: yup
        .array()
        .test("fieldMappingModalTest", copies.get("add.atleast.one"), function (fieldMapping: any) {
          return flatten(fieldMapping.map((item: any) => item.recipientFieldOptionIds)).length > 0;
        })
    });
  }, [copies]);

  return validation;
}

export function getOptions(field: ApiField) {
  if (field) {
    if (field.renderType === FieldRenderType.NESTED_MULTI_SELECT) {
      return flatten(field.options.map(inner => inner.childOptions || []));
    } else {
      return field.options || [];
    }
  }
  return [];
}
export function getFieldOptions(field: ApiField): Array<FormFieldOption> {
  if (field) {
    return getOptions(field).map(item => ({ label: item.value, value: item.id }));
  }
  return [];
}
